/**
 * Shortlink option state for multi-drop edits that start at "keep each drop's
 * own" (multi-country bulk and multi-country sent/scheduled wizards).
 * For Media Devoted | Created By Ciro Autiero
 */

import { useState } from 'react';

import {
  shortlinkPick,
  type ClickIdStructureValue,
  type DomainSchemeValue,
} from '@/features/smswiser-campaigns/utils/shortlinkOptionState';

export function useShortlinkOptionsState() {
  const [clickIdStructure, setClickIdStructure] = useState<ClickIdStructureValue>('unchanged');
  const [domainScheme, setDomainScheme] = useState<DomainSchemeValue>('unchanged');
  /** A concrete pick on either option — counts as a change, like forceSend. */
  const picked =
    shortlinkPick(clickIdStructure) !== undefined || shortlinkPick(domainScheme) !== undefined;
  return { clickIdStructure, setClickIdStructure, domainScheme, setDomainScheme, picked };
}
